"use client";
import React, { useState, useEffect } from "react";
import Head from "next/head";
import { Box, TablePagination } from "@mui/material";
import CustomSearchBar from "@/components/Elements/CustomSearchBar";
import { useRouter, useSearchParams } from "next/navigation";
import { useFetchBands } from "@/hooks";
import BandCard from "@/components/Core/Bands/BandCard";
import BandDetailsPage from "@/components/Core/Bands/BandDetailsPage";
import { paginate } from "@/utils/utility";

const ITEMS_PER_PAGE = [20, 50, 100, 200, 500];

export default function BandsLayout() {
  const internalLink = useSearchParams().get("internalLink");
  const [searchTerm, setSearchTerm] = useState("");
  const router = useRouter();

  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const { bands, loading } = useFetchBands(true);
  const getFilteredResults = () => {
    if (!searchTerm) return bands;

    // Convert the searchTerm to lowercase for case-insensitive comparison
    const lowerCaseSearchTerm = searchTerm.toLowerCase().trim();

    return bands.filter((item) =>
      item.title_lowercase.includes(lowerCaseSearchTerm)
    );
  };

  const handleChangePage = (event, value) => {
    setCurrentPage(value);
  };
  const handleChangeItemsPerPage = (event) => {
    setItemsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };
  if (internalLink) {
    return <BandDetailsPage />;
  }
  return (
    <div style={{ padding: 30 }}>
      <Box>
        <Head key="unique-key">
          <meta name="keywords" content="Bands that perform Live" />
          <meta
            name="description"
            content="Live local music bands shows and concerts near me."
          />
          <meta property="og:title" content="Bands that perform Live" />
          <meta
            property="og:description"
            content="Live local music bands shows and concerts near me."
          />
          <title>Webtunes Bands List</title>
        </Head>
        <CustomSearchBar
          handleChange={(searchTerm) => setSearchTerm(searchTerm)}
          placeholder="Search bands..."
        />
        {/* H1 Header for SEO */}
        <Box sx={{ width: "100%", textAlign: "center", mb: 2 }}>
          <h1>The Bands</h1>
        </Box>
        <BandCard
          data={paginate(getFilteredResults(), currentPage + 1, itemsPerPage)}
          loading={loading}
        />
        {getFilteredResults().length > itemsPerPage && (
          <TablePagination
            component="div"
            count={getFilteredResults().length}
            page={currentPage}
            onPageChange={handleChangePage}
            rowsPerPage={itemsPerPage}
            onRowsPerPageChange={handleChangeItemsPerPage}
            rowsPerPageOptions={ITEMS_PER_PAGE}
          />
        )}
      </Box>
    </div>
  );
}
